import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Key } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material';

// import Container from 'components/Container';

const BtnBox = styled(Box)(() => ({
  display: 'flex',
  gap: '10px'
}));

function CtaWithRightButtons({
  title = '',
  contentText = '',
  conditionalText = '',
  btnAction,
  razontext,
  showAdvert = false
}) {
  const { palette } = useTheme();
  return (
    <Box width="100%">
      <Box marginBottom={4}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            fontWeight: 700
          }}
        >
          {title}
        </Typography>
        <Typography variant="h5" color="text.secondary" mb={2}>
          {contentText}
        </Typography>
        {showAdvert && (
          <Typography color={palette.primary.main} textAlign="center" variant="body1" fontWeight={600}>
            (La cancelación del envío y devolución del dinero está sujeta a verificación por parte de Dagpacket)
          </Typography>
        )}
      </Box>
      <Box
        display="flex"
        gap="30px"
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
      >
        <Box flexGrow={1}>
          <Typography fontWeight={700} variant="h6" gutterBottom>
            Tipo de acción
          </Typography>
          <Typography>{conditionalText}</Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap="10px" marginTop={{ xs: 2, md: 0 }}>
          {razontext && (
            <Box>
              <Typography variant="subtitle2">Razon</Typography>
              <Typography>{razontext}</Typography>
            </Box>
          )}
          {Array.isArray(btnAction) ? (
            <BtnBox>
              {btnAction.map((item) => (
                <div key={item.id}>{item.component}</div>
              ))}
            </BtnBox>
          ) : (
            btnAction
          )}
          {/* <Button variant="contained" color="primary" size="large">
            Apply
          </Button> */}
          {/* <Box component={Button} variant="outlined" color="primary" size="large" marginLeft={2}>
            Explore
          </Box> */}
        </Box>
      </Box>
    </Box>
  );
}

export default CtaWithRightButtons;
